
import { BookOpen } from "lucide-react";

const EmptyContent = () => {
  return (
    <div className="text-center py-6">
      <BookOpen size={48} className="mx-auto text-gray-300 mb-3" />
      <h3 className="text-lg font-medium text-nation-blue mb-2">
        No related content yet
      </h3>
      <p className="text-gray-600 text-sm">
        We're working on educational materials for this topic.
      </p>
    </div>
  );
};

export default EmptyContent;
